import { color } from 'framer-motion';
import { useState } from 'react';

const OurBenifits=() =>{
  const [hoveredIndex, setHoveredIndex] = useState(null);
  
  const challenges = [
    {
      title: "Deep understanding of SAP project life cycles",
      color: "#C84B31" // Custom red
    },
    {
      title: "Proven track record across industries and geographies",
      color: "#D39F2D" // Custom amber
    },
    {
      title: "Dedicated account managers and single point of contact",
      color: "#2F3133" // Custom dark gray
    },
    {
      title: "Seamless integration with your in-house teams",
      color: "#C66B90" // Custom rose
      },
      
      {
        title: "Transparent processes and SLA-driven delivery",
          color:"#2F3133" // Custom dark gray
    }
  ];

  return (
    <div className="w-full min-h-screen py-16 px-4 sm:px-6 lg:px-8 relative overflow-hidden" 
      style={{ backgroundColor: "#141D26" }}>
      
      {/* Envelope background design */}
      <div className="absolute inset-0 bg-gradient-to-b from-slate-800 to-slate-900"></div>
      
      {/* Custom envelope fold lines */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden">
        {/* Top fold */}
        <div className="absolute top-0 left-0 w-full h-1/3" 
          style={{ 
            background: "linear-gradient(180deg, #1A2533 0%, #141D26 100%)",
            clipPath: "polygon(0 0, 100% 0, 50% 100%)",
            opacity: 0.3
          }}>
        </div>
        
        {/* Left fold */}
        <div className="absolute top-0 left-0 w-1/3 h-full" 
          style={{ 
            background: "linear-gradient(90deg, #1A2533 0%, #141D26 100%)",
            clipPath: "polygon(0 0, 100% 50%, 0 100%)",
            opacity: 0.2
          }}>
        </div>
        
        {/* Right fold */}
        <div className="absolute top-0 right-0 w-1/3 h-full" 
          style={{ 
            background: "linear-gradient(270deg, #1A2533 0%, #141D26 100%)",
            clipPath: "polygon(100% 0, 0 50%, 100% 100%)",
            opacity: 0.2
          }}>
        </div>
        
        {/* Bottom fold */}
        <div className="absolute bottom-0 left-0 w-full h-1/4" 
          style={{ 
            background: "linear-gradient(0deg, #1A2533 0%, #141D26 100%)",
            clipPath: "polygon(0 100%, 100% 100%, 50% 0)",
            opacity: 0.15
          }}>
        </div>
      </div>
      
      <div className="max-w-6xl mx-auto relative z-10">
        {/* Heading */}
        <h2 className="text-3xl md:text-3xl lg:text-3xl font-bold text-white text-center mb-20">
        Why We’re Your Best Choice...
        </h2>
        
        {/* Challenge cards with overlap and rotation */}
        <div className="relative h-80 md:h-72 mx-auto max-w-3xl">
          {challenges.map((challenge, index) => (
            <div 
              key={index}
              className={`absolute transform transition-all duration-500 ease-in-out
                ${index === 0 ? '-rotate-12 translate-x-4 -translate-y-4 z-30' : ''}
                ${index === 1 ? 'rotate-6 translate-x-20 md:translate-x-32 translate-y-2 z-20' : ''}
                ${index === 2 ? '-rotate-6 -translate-x-8 translate-y-12 z-10' : ''}
                ${index === 3 ? 'rotate-12 translate-x-16 md:translate-x-24 translate-y-24 z-0' : ''}
                ${hoveredIndex === index ? 'scale-110 z-40 rotate-0' : ''}
              `}
              style={{
                width: "280px",
                transformOrigin: 'center center',
                transformStyle: 'preserve-3d',
                boxShadow: hoveredIndex === index ? '0 20px 25px -5px rgba(0, 0, 0, 0.4)' : '0 10px 15px -3px rgba(0, 0, 0, 0.3)'
              }}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <div 
                className="bg-white rounded-lg shadow-lg overflow-hidden cursor-pointer transition-all duration-300"
                style={{ 
                  height: "90px",
                  transform: hoveredIndex === index ? 'translateY(-10px)' : 'translateY(0)'
                }}
              >
                <div className="h-full flex items-center justify-center p-4">
                  <p 
                    className="text-lg md:text-lg "
                    style={{ color: challenge.color }}
                  >
                    {challenge.title}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default OurBenifits;